(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/components/home-button.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/components/home-button.js');

'use strict';

const Button = svs.ui.ReactButton;
const {
  PinIcon
} = svs.lyckoplatsen.shared_utils.react.components;
const {
  isSelfService
} = svs.core.config.data.svsconfig;
const {
  useHomeLocation,
  useHomeLocationSelfService
} = svs.lyckoplatsen.components.page_play.react.hooks;
const {
  shouldShowPinAtom
} = svs.lyckoplatsen.components.page_play.jotai.atoms;
const {
  isMovingAtom
} = svs.lyckoplatsen.shared_map.atoms;
const {
  useAtomValue
} = jotai;
const {
  CONSTANTS
} = svs.lyckoplatsen.components.shared_constants;
const HomeButton = () => {
  const isMoving = useAtomValue(isMovingAtom);
  const shouldShowPin = useAtomValue(shouldShowPinAtom);
  const handleHomeLocation = useHomeLocation();
  const handleHomeLocationSelfService = useHomeLocationSelfService();
  const handleHomeLocationClick = () => {
    svs.components.analytics.trackEvent({
      category: 'Lyckoplatsen',
      action: 'Sök',
      opt_label: CONSTANTS.LOCATION_TYPES.HOME
    });
    if (svs.core.config.data.svsconfig.isSelfService) {
      handleHomeLocationSelfService();
    } else {
      handleHomeLocation();
    }
  };
  return React.createElement("div", {
    className: "lp-home-button"
  }, React.createElement(Button, {
    disabled: isMoving || shouldShowPin,
    onClick: () => handleHomeLocationClick()
  }, isSelfService ? 'Spela på min hemadress ' : 'Hemadress ', " ", React.createElement(PinIcon, {
    color: "black"
  })));
};
setGlobal('svs.lyckoplatsen.components.page_play.react.components', {
  HomeButton
});

 })(window);